export default "__VITE_ASSET__Dm5xbO4G__"